import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { articles, getHotArticles, getLatestArticles } from '@/mocks/articles';

export default function Home() {
  const { t } = useTranslation();
  const hotArticles = getHotArticles();
  const latestArticles = getLatestArticles();
  const heroArticle = articles[0];

  const webSiteSchema = {
    name: '黑料吃瓜在线',
    url: 'http://hngzxny.cn/',
    description: '最新娱乐资讯聚合平台，聚焦明星八卦、网红动态、综艺热点与影视资讯。一手吃瓜速递，精彩不容错过。',
    inLanguage: 'zh-CN',
  };

  const webPageSchema = {
    name: '黑料吃瓜在线 - 首页',
    url: 'http://hngzxny.cn/',
    isPartOf: { '@type': 'WebSite', name: '黑料吃瓜在线' },
  };

  return (
    <>
      <SchemaOrg type="WebSite" data={webSiteSchema} />
      <SchemaOrg type="WebPage" data={webPageSchema} />

      <main>
        <Navbar />

        <header className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20cityscape%20at%20night%20with%20vibrant%20neon%20lights%20and%20a%20bustling%20urban%20atmosphere%2C%20modern%20Chinese%20city%20with%20towering%20skyscrapers%2C%20warm%20golden%20and%20amber%20glowing%20lights%20reflecting%20on%20wet%20streets%2C%20energetic%20nightlife%20vibe%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20contrast%20with%20deep%20shadows%20and%20bright%20highlights%2C%20luxurious%20and%20glamorous%20mood&width=1800&height=900&seq=hero-home-2026-x1&orientation=landscape"
            alt="黑料吃瓜在线 - 最新娱乐资讯"
            title="黑料吃瓜在线 - 最新娱乐资讯平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
            <span className="px-4 py-1.5 rounded-full text-sm font-medium bg-accent-500/90 text-background-50 mb-6 whitespace-nowrap">
              每日更新 一手吃瓜速递
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 text-center max-w-3xl leading-tight text-balance">
              最新娱乐资讯
              <br />
              <span className="text-accent-400">一手吃瓜速递</span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-50/80 text-center max-w-xl leading-relaxed">
              聚焦明星八卦、网红动态、综艺热点与影视资讯，每日更新最新最全的娱乐头条
            </p>
            <div className="flex items-center gap-4 mt-8">
              <Link
                to={`/article/${heroArticle.id}`}
                className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                今日头条
              </Link>
              <Link
                to="/category/celebrity"
                className="px-8 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/15 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                浏览更多
              </Link>
            </div>
          </div>
        </header>

        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  热门
                  <span className="text-accent-500">爆料</span>
                </h2>
                <p className="mt-2 text-sm text-foreground-500">最受关注的头条资讯</p>
              </div>
              <Link
                to="/category/celebrity"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="relative">
              <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
                {hotArticles.map((article) => (
                  <div key={article.id} style={{ scrollSnapAlign: 'start' }}>
                    <ArticleCard article={article} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100 px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  最新
                  <span className="text-primary-600">爆料</span>
                </h2>
                <p className="mt-2 text-sm text-foreground-500">刚刚出炉的新鲜资讯</p>
              </div>
              <Link
                to="/category/film"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="relative">
              <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
                {latestArticles.map((article) => (
                  <div key={article.id} style={{ scrollSnapAlign: 'start' }}>
                    <ArticleCard article={article} variant="compact" />
                  </div>
                ))}
                {latestArticles.length < 4 && articles.filter(a => !a.isNew && !a.isHot).slice(0, 4 - latestArticles.length).map((article) => (
                  <div key={article.id} style={{ scrollSnapAlign: 'start' }}>
                    <ArticleCard article={article} variant="compact" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="relative w-full py-20 md:py-28 px-4 md:px-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vibrant%20media%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20news%2C%20modern%20studio%20setup%20with%20warm%20ambient%20lighting%2C%20professional%20broadcast%20environment%20with%20glowing%20monitors%2C%20dynamic%20and%20energetic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20rich%20amber%20and%20golden%20tones%2C%20high-end%20production%20design&width=1800&height=600&seq=cta-home-2026-x2&orientation=landscape"
            alt="娱乐资讯订阅"
            title="订阅黑料吃瓜在线最新资讯"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/85 via-secondary-900/60 to-secondary-900/40"></div>

          <div className="relative z-10 max-w-[1280px] mx-auto">
            <div className="max-w-lg">
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                不想错过
                <br />
                任何精彩爆料？
              </h2>
              <p className="mt-4 text-base text-background-50/70 leading-relaxed max-w-md">
                订阅我们的每日推送，第一时间获取最新娱乐资讯和独家爆料内容。
              </p>
              <form
                className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md"
               
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.currentTarget);
                  const honeypot = formData.get('company_alt') as string;
                  if (honeypot && honeypot.trim() !== '') return;
                }}
              >
                <div className="honeypot-field">
                  <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱地址"
                  required
                  className="flex-1 bg-background-50/10 border border-background-50/20 rounded-full px-5 py-3 text-sm text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-accent-500 backdrop-blur-sm"
                />
                <button
                  type="submit"
                  className="px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  立即订阅
                </button>
              </form>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}